<template>
  <van-row :class="bottom ? 'fixed-bottom btn-wrap footer' : 'btn-wrap footer'">
    <van-button :class="['btn','cancel', firstText === '取 消' || '返 回' ? 'cancel' : '', borderRadius ? 'btn-radius' : ''].join(' ')" @click="firstClick">{{firstText}}</van-button>
    <van-button :class="['btn submit', borderRadius ? 'btn-radius' : ''].join(' ')" v-if="loading" @click="secondClick" :loading="loading" loading-type="spinner">{{secondText}}</van-button>
    <van-button :class="['btn submit', borderRadius ? 'btn-radius' : ''].join(' ')" v-else @click="secondClick">{{secondText}}</van-button>
  </van-row>
</template>

<script>
import {
  Row,
  Button
} from 'vant'

export default {
  name: 'buttonRow',
  props: {
    firstClick: {
      type: Function
    },
    firstText: {
      type: String,
      default: '取 消'
    },
    secondShow: {
      type: Boolean,
      default: true
    },
    secondClick: {
      type: Function
    },
    secondText: {
      type: String,
      default: '保 存'
    },
    loading: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    borderRadius: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Row.name]: Row,
    [Button.name]: Button
  }
}
</script>

<style lang="less" scoped>
  .footer{
    width: 100%;
    position: fixed;
    bottom: 0px;
    display: flex;
    height: 160px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 16px 24px 0px;
    box-shadow: 0px 0px 10px 2px rgb(230, 227, 227);
    .cancel{
      width: 254px !important;
      height: 80px !important;
      box-sizing: border-box !important;
      background-color: #fff !important;
      border: #3378FF 1Px solid !important;
      margin-right: 16px !important;
      color: #3378FF !important;
      font-size: 28px !important;
      text-align: center;
      line-height: 80px;
    }
    .submit{
      width: 432px !important;
      height: 80px !important;
      color: #fff !important;
      text-align: center !important;
      line-height: 80px !important;
      background-color: #3378FF !important;
      font-size: 28px !important;
    }
  }
  .btn-wrap {
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
    .van-button {
      border: 0;
      width: 375px;
      height:96px;
      font-size:32px;
      font-weight:500;
      line-height: 96px;
      color:rgba(255,255,255,1);
      // background: linear-gradient(90deg, #366BFF 0%, #64A0FF 100%);
      background: #366BFF;
    }
    .btn:nth-child(1){
      background: #FAFAFA;
      color: #2372FF;
    }
    .btn.cancel{
      background: #D4D6DC;
      color: #fff;
    }
    .btn-radius{
      width: 330px;
      height: 90px;
      border-radius: 12px;
      margin: 0 30px 32px;
      background: #2372FF;
    }
    .btn-radius:nth-child(1){
      margin-right: 15px;
    }
    .btn-radius:nth-child(2){
      margin-left: 15px;
    }
  }

  .fixed-bottom {
    width: 100%;
    position: absolute;
    bottom: 0px;
  }
</style>
